<template>
  <div>
    <div class="innerBox">
      <div class="innerTitle">
        <el-button type="primary" size="small" @click="openDia">新增</el-button>
        <div class="screenBox">
          <el-select v-model="contractorInfoId" placeholder="请选择所属单位" size="small" @change="selectChange" style="width: 30%" clearable>
            <el-option label="本企业" :value="0" />
            <el-option label="外访人员" :value="-1" />
            <el-option v-for="item in contractorList" :key="item.id" :value="item.id" :label="item.contrName" />
          </el-select>
          <el-select v-model="inOut" size="small" style="width: 30%" placeholder="请选择进出场" @change="selectChange" clearable>
            <el-option label="进厂" :value="0" />
            <el-option label="出场" :value="1" />
          </el-select>
          <Input search enter-button placeholder="请输入姓名/工号" style="width: 35%" v-model="searchContent"
            @on-search="searchInp" />
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: 'rgb(232,232,232)', height: '55px', textAlign: 'center' }"
        :row-style="{ height: '55px' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%">
        <el-table-column
          type="index"
          :index='(index) => {return index + 1 + (curPage-1)*limit}'
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="empNo"
          label="工号">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名">
        </el-table-column>
        <el-table-column
        prop="contrName"
          label="所属单位" />
        <el-table-column
          prop="depName"
          label="部门">
        </el-table-column>
        <el-table-column
          prop="jodName"
          label="岗位">
        </el-table-column>
        <el-table-column
          label="联系电话">
          <template slot-scope="scope">{{ scope.row.aphone||scope.row.bphone }}</template>
        </el-table-column>
        <el-table-column
          label="进/出场">
          <template slot-scope="{ row }">
            <span v-if="row.inOut === 0" style="color: #67C23A">进场</span>
            <span v-if="row.inOut === 1" style="color: #E6A23C">出场</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="enterTime"
          width="155"
          label="进场时间">
        </el-table-column>
        <el-table-column
          prop="recordTime"
          width="155"
          label="出场时间">
          <template slot-scope="{ row }">
            {{ row.inOut === 0 ? '' : row.recordTime }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="{ row }">
            <el-link type="primary" v-if="row.inOut === 0" style="margin-right: 10px" @click="out(row)">出场</el-link>
            <el-link type="danger" @click="deleteList(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
    </div>
    <!-- 新增/编辑的弹窗 -->
    <div class="formBox">
      <el-dialog title="人员信息" :visible.sync="dialogFormVisible" width="23%" @close="closeDia">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="所属单位" :label-width="formLabelWidth" size="small" prop="type"
          style="margin-top: 14px">
            <el-select v-model="form.type" placeholder="请选择所属单位" style="width: 76%" @change="diaSelect">
               <el-option label="本企业" :value="0" />
               <el-option label="承包商" :value="1" />
              <el-option label="外访人员" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="承包商" v-if="form.type === 1" :label-width="formLabelWidth" size="small" prop="contractorInfoId"
          style="margin-top: 14px">
            <el-select v-model="form.contractorInfoId" placeholder="请选择承包商" style="width: 76%" @change="diaSelect1">
              <el-option v-for="item in contractorList" :key="item.id" :value="item.id" :label="item.contrName" />
            </el-select>
          </el-form-item>
          <el-form-item label="进出场" :label-width="formLabelWidth" prop="inOut">
            <el-select v-model="form.inOut" placeholder="进出场" style="width: 76%" size="small">
              <el-option label="进场" :value="0" />
              <el-option label="出场" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" v-if="form.type === 2 || form.type === ''" :label-width="formLabelWidth" prop="name">
            <el-input v-model="form.name" auto-complete="off" size="small" style="width: 76%" />
          </el-form-item>
          <el-form-item v-if="form.type === 0 || form.type === 1" label="人员" :label-width="formLabelWidth" prop="employeeId">
            <el-select label="人员" v-model="form.employeeId" placeholder="请选择人员" style="width: 76%" size="small">
              <el-option v-for="item in personList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
          <el-form-item label="时间" :label-width="formLabelWidth" prop="recordTime">
            <el-date-picker v-model="form.recordTime" type="datetime" placeholder="选择日期时间" size="small"
              value-format="yyyy-MM-dd HH:mm:ss" style="width: 76%" />
          </el-form-item>
          <el-form-item v-if="form.type === 2" label="联系电话" :label-width="formLabelWidth" prop="phone">
            <el-input v-model="form.phone" auto-complete="off" size="small" style="width: 76%" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin:auto">
          <el-button @click="closeDia" size="small">取 消</el-button>
          <el-button type="primary" @click="sureBtn('form')" size="small">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { peopleInOutList, getStaffList, addPeopleInOut, peopleOut, deletePeopleInOut } from '@/api/processManager'
import { getDepartmentList } from '@/api/wholeProcess'
export default {
  name: 'peopleInOut',
  data() {
    return {
      tableData: [],
      total: 0,
      limit: 10,
      curPage: 1,
      contractorInfoId: '',
      inOut: '',
      searchContent: '',
      contractorList: [],
      form: {},
      dialogFormVisible: false,
      formLabelWidth: '100px',
      personList: [],
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        inOut: [
          { required: true, message: '请选择进出场', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择所属单位', trigger: 'change' }
        ],
        employeeId: [
          { required: true, message: '请选择人员', trigger: 'change' }
        ],
        recordTime: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        contractorInfoId: [
          { required: true, message: '请选择承包商', trigger: 'blur' }
        ],
      },
    }
  },
  created() {
    this.getData();
    this.getContractorList();
  },
  methods: {
    // 获取表格数据
    getData() {
      peopleInOutList({
          limit: this.limit,
          curPage: this.curPage,
          contractorInfoId: this.contractorInfoId,
          inOut: this.inOut,
          searchContent: this.searchContent
        }).then(res => {
        this.tableData = res.body.data;
        this.total = res.body.cum
      })
    },
    // 获取承包商列表（下拉框用）
    getContractorList() {
      getDepartmentList({ limit: 100, curPage: 1 }).then(res => {
        this.contractorList = res.body.data;
      })
    },
    curPageChange(val) {
      this.curPage = val;
      this.getData();
    },
    selectChange() {
      this.getData();
    },
    searchInp() {
      this.getData()
    },
    // 弹窗的一些事件
    openDia() {
      this.dialogFormVisible = true;
    },
    closeDia() {
      this.$refs['form'].resetFields()
      this.dialogFormVisible = false
      this.form = {}
      // this.form = {...this.form2}
      // this.isEdit = false
    },
    // 根据承包商和本企业查询人员
    diaSelect(val) {
      this.personList = [];
      if(this.form.type === 0){
        getStaffList({ contractorId: 0 }).then(res => {
          this.personList = res.body.data;
        })
      }
    },
    diaSelect1(val) {
      getStaffList({ contractorId: val }).then(res => {
        this.personList = res.body.data;
      })
    },
    // 弹窗表单的确认按钮
    sureBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addPeopleInOut({ ...this.form }).then(res => {
            this.$message.success('添加成功');
            this.closeDia();
            this.getData();
          })
        } else {
          return false;
        }
      });
    },
    // 出场
    out(row) {
      peopleOut({ id: row.id }).then(res => {
        this.$message.success('操作成功');
        this.getData();
      })
    },
    deleteList(row) {
      deletePeopleInOut(row.id).then(res => {
        this.$message.success('删除成功');
        this.getData();
      })
    }
  }
}
</script>

<style scoped>
.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}
.innerBox {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 10px
}
.innerTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.innerTitle .screenBox {
  width: 45%;
  display: flex;
  justify-content: space-between;
}
.formBox /deep/ .el-form-item {
  margin-bottom: 10px
}
.formBox /deep/ .el-form-item__error {
  padding-top: 2px
}
</style>
